import React from 'react';
import type { ProductNameLine } from 'autogen/swagger/all';
import usePageContext from 'hooks/user/usePageContext';
import ChanelPageTitleNameRenderer from './ChanelPageTitleNameRenderer';
import PageTitleNameRenderer from './PageTitleNameRenderer';

export default function PageTitleNameRendererMapper({ lines }: { lines: ProductNameLine[] }): JSX.Element {
    const pageContext = usePageContext();
    const brandContext = pageContext?.brandContext;

    return brandContext && brandContext === 'chanel' ? (
        <ChanelPageTitleNameRenderer lines={lines} />
    ) : (
        <PageTitleNameRenderer lines={lines} />
    );
}
